// extracted by mini-css-extract-plugin
export default {"container":"GroupedKeyConceptsView__container___P06bt","text":"GroupedKeyConceptsView__text___u9Tom","boldText":"GroupedKeyConceptsView__boldText___Sd03H"};